"use strict";var r=require("./arrayFindLastIndex.cjs");exports.arrayFindLast=function(a,n){var t=r.arrayFindLastIndex(a,n);return-1===t?void 0:a[t]};
//# sourceMappingURL=arrayFindLast.cjs.map
